<div class="modal-background"></div>
<form [formGroup]="this.formGroup" aria-labelledby="modalTitle" role="document" (ngSubmit)="onSubmit()" class="modal-card">
	<header class="modal-card-head">
		<p id="modalTitle" class="modal-card-title">Select Environment</p>
		<button type="button" (click)="onClickCancel()" class="delete" aria-label="close"></button>
	</header>
	<section class="modal-card-body">
		<div class="field">
			<label for="environment" class="label">Current Environment</label>
			<div class="control">
				<div class="select">
					<select id="environment" formControlName="environment" required>
						<option *ngFor="let environment of this.environments | keyvalue: this.originalOrder" [value]="environment.key">
							{{ environment.value }}
						</option>
					</select>
				</div>
			</div>
		</div>
	</section>
	<footer class="modal-card-foot">
		<button type="submit" class="button is-success">Save changes</button>
		<button type="button" (click)="onClickCancel()" class="button">Cancel</button>
	</footer>
</form>
